module.exports = __webpack_public_path__ + "static/media/BlackborderHeart.e501c462.svg";